import { Tracker } from './tracker';
import { BOOK_APPOINTMENT_EVENT } from './trackingConstants';

export interface BookAppointmentConversion {
  saleOrderId: string;
  totalDollars: number;
  currency?: string | null;
  shopId: string;
  shopName?: string;
  gaMeasurementId?: string | null;
  metaPixelId?: string | null;
}

/**
 * Reports a confirmed booking to the brand's ad-conversion pixels (GA4, Meta).
 * Separate from the internal `booking_completed` event and sent once per cart;
 * never for waitlist joins or gift cards.
 */
export const trackBookAppointment = ({
  saleOrderId,
  totalDollars,
  currency,
  shopId,
  shopName,
  gaMeasurementId,
  metaPixelId,
}: BookAppointmentConversion): void => {
  Tracker.track(
    BOOK_APPOINTMENT_EVENT,
    {
      saleOrderId,
      totalDollars: String(totalDollars),
      currency: (currency || 'USD').toUpperCase(),
      shopId,
      shopName,
      shopGaMeasurementId: gaMeasurementId ?? '',
      shopMetaPixelId: metaPixelId ?? '',
    },
    { whitelist: ['googleAnalytics', 'metaPixel'] },
  );
};
